import { AxiosError, AxiosResponse } from 'axios';
import {
  DocumentoProjeto,
  EtapaEducacaoDTO,
  EtapaProjeto,
  ModalidadeDTO,
  PrincipioValorDTO,
  ProjetoType,
  StatusEtapa,
  StatusEtapaResponseDTO,
  indexOfEtapa,
} from 'models/projeto';
import { getMergedParamsFromObject, toRequest } from 'utils/RequestUtils';
import { getApis } from '../library/Apis';

export const getEndpoint = (version = 1, path = '/projeto/pufv') => {
  return `${getApis().apis.bff}v${version}${path}`;
};

export const getEndpointBff = (version = 1, path = '/projeto/pufv') => {
  return `${getApis().apis.bff}v${version}${path}`;
};

export const getProjeto = (id: string | number) => {
  const url = `${getEndpointBff()}/${id}`;
  return toRequest<ProjetoType>('get', [url]);
};

export const getStatusEtapa = (
  idProjeto: string | number,
  indexEtapa: string | number
) => {
  const url = `${getEndpointBff(1, '/avaliacao/pufv')}?${getMergedParamsFromObject(
    {
      idProjeto,
      etapa: indexEtapa,
    }
  )}`;
  return toRequest<StatusEtapaResponseDTO>('get', [url]);
};

export const getEtapas = (flgNovoTemplate: boolean) => {
  const url = getEndpoint(
    1,
    `/escola/etapa-ensino?flgNovoTemplate=${String(flgNovoTemplate)}`
  );
  return toRequest<EtapaEducacaoDTO[]>('get', [url]);
};

export const getModalidades = () => {
  const url = getEndpoint(1, '/escola/modalidade');
  return toRequest<ModalidadeDTO[]>('get', [url]);
};

export const getPrincipiosValores = () => {
  const url = getEndpoint(1, '/escola/principio-valor');
  return toRequest<PrincipioValorDTO[]>('get', [url]);
};

export const postProjeto = (pre: Partial<ProjetoType>) => {
  const url = getEndpointBff(1, `/projeto/pufv`);
  return toRequest<{ id: number }>('post', [url, pre]);
};

export const putProjeto = (projeto: Partial<ProjetoType>) => {
  const url = getEndpointBff(1, `/projeto/pufv/${projeto.id ?? ''}`);
  return toRequest('put', [url, projeto]);
};

type ArquivoProjeto = {
  etapa: EtapaProjeto;
  idProjeto: string;
  cooperativa: string;
  file: File;
};

export const uploadDocumento = (
  documento: ArquivoProjeto,
  callbackSuccess: (
    resp: AxiosResponse<string | DocumentoProjeto>,
    file: ArquivoProjeto
  ) => void,
  callbackError: (err: AxiosError) => void,
  callbackProgress: (obj: { percent: number }, file: ArquivoProjeto) => void
) => {
  const url = getApis().apis.bff.concat('v1/documento/compressing');
  const fd = new FormData();
  fd.append('etapa', documento.etapa);
  fd.append('projeto', documento.idProjeto);
  fd.append('coop', documento.cooperativa);
  fd.append('file', documento.file);

  return toRequest('post', [
    url,
    fd,
    {
      headers: {
        'content-type':
          'multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s',
      },
      onUploadProgress: ({ total, loaded }) => {
        const percent = Number(Math.round((loaded / (total ?? 1)) * 100).toFixed(2));
        callbackProgress({ percent }, documento);
      },
    },
  ])
    .then((resp) => {
      callbackSuccess(resp, documento);
    })
    .catch((error) => {
      callbackError(error);
    });
};

export const deleteDocumento = (id: string) => {
  const url = getApis().apis.bff.concat(`v1/documento/${id}`);
  return toRequest<void>('delete', [url]);
};

export const postVisualizadoCoordenador = (id: number, value: boolean) => {
  const url = getEndpointBff(
    1,
    `/projeto/pufv/${id}/visualizar/coordenador?flgCheckCoordenador=${String(
      value
    )}`
  );
  return toRequest<void>('put', [url]);
};

export const postVisualizadoProfGestor = (id: number, value: boolean) => {
  const url = getEndpointBff(
    1,
    `/projeto/pufv/${id}/visualizar/prof-gestor?flgCheckProfGestor=${String(
      value
    )}`
  );
  return toRequest<void>('put', [url]);
};

export const getVisualizadoIsGestor = (id: number) => {
  const url = getEndpointBff(1, `/projeto/pufv/${id}/is-gestor`);
  return toRequest<boolean>('get', [url]);
};

export const pathRegistraLogin = () => {
  const url = getEndpointBff(1, '/usuario/registrar-login');
  return toRequest<void>('patch', [url]);
};

export const putAvaliacao = (opt: {
  comentario?: string;
  ldap: string;
  etapa: EtapaProjeto;
  nomeAssessor: string;
  status: StatusEtapa;
  idProjeto: number;
}) => {
  const url = getEndpointBff(1, `/avaliacao/pufv?idProjeto=${opt.idProjeto}`);
  return toRequest<void>('put', [
    url,
    {
      comentario: opt.comentario,
      cpfAssessor: opt.ldap,
      etapa: indexOfEtapa(opt.etapa),
      nomeAssessor: opt.nomeAssessor,
      status: opt.status,
    },
  ]);
};
